import { gql } from '@apollo/client'

export const GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE = gql`
  query GetAllConfigAppPageElementsByConfigAppPageId($configAppPageId: Int!) {
    getAllConfigAppPageElementsByConfigAppPageId(
      configAppPageId: $configAppPageId
    ) {
      id
      config_app_page_id
      order
      layout
      json_config
      json_items_config
    }
  }
`

export const ORDER_CONFIG_APP_PAGE_ELEMENT = gql`
  mutation OrderConfigAppPageElement(
    $pageId: Int!
    $input: [OrderElementInput!]!
  ) {
    orderConfigAppPageElement(pageId: $pageId, input: $input)
  }
`

export const ORDER_CONFIG_APP_PAGE_ELEMENT_ITEMS = gql`
  mutation OrderConfigAppPageElementItems(
    $elementId: Int!
    $json_items_config: String!
  ) {
    orderConfigAppPageElementItems(
      elementId: $elementId
      json_items_config: $json_items_config
    )
  }
`

export const DELETE_CONFIG_APP_PAGE_ELEMENT = gql`
  mutation DeleteConfigAppPageElement($id: Int!) {
    deleteConfigAppPageElement(id: $id)
  }
`

export const CREATE_OR_UPDATE_ELEMENT_Spacer = gql`
  mutation CreateOrUpdateElement_Spacer(
    $inputGeneral: ConfigAppPageElementInput!
    $inputElement: ConfigAppPageElementInput_Spacer!
  ) {
    createOrUpdateElement_Spacer(
      inputGeneral: $inputGeneral
      inputElement: $inputElement
    )
  }
`

export const CREATE_OR_UPDATE_ELEMENT_HtmlContent = gql`
  mutation CreateOrUpdateElement_HtmlContent(
    $inputGeneral: ConfigAppPageElementInput!
    $inputElement: ConfigAppPageElementInput_HtmlContent!
  ) {
    createOrUpdateElement_HtmlContent(
      inputGeneral: $inputGeneral
      inputElement: $inputElement
    )
  }
`

export const CREATE_OR_UPDATE_ELEMENT_HeaderText = gql`
  mutation CreateOrUpdateElement_HeaderText(
    $inputGeneral: ConfigAppPageElementInput!
    $inputElement: ConfigAppPageElementInput_HeaderText!
  ) {
    createOrUpdateElement_HeaderText(
      inputGeneral: $inputGeneral
      inputElement: $inputElement
    )
  }
`

export const CREATE_OR_UPDATE_ELEMENT_ButtonsBox = gql`
  mutation CreateOrUpdateElement_ButtonsBox(
    $inputGeneral: ConfigAppPageElementInput!
    $inputElement: ConfigAppPageElementInput_ButtonsBox!
  ) {
    createOrUpdateElement_ButtonsBox(
      inputGeneral: $inputGeneral
      inputElement: $inputElement
    )
  }
`

export const CREATE_OR_UPDATE_ELEMENT_BannerImageSingle = gql`
  mutation CreateOrUpdateElement_BannerImageSingle(
    $inputGeneral: ConfigAppPageElementInput!
    $inputElement: ConfigAppPageElementInput_BannerImageSingle!
  ) {
    createOrUpdateElement_BannerImageSingle(
      inputGeneral: $inputGeneral
      inputElement: $inputElement
    )
  }
`

export const CREATE_OR_UPDATE_ELEMENT_BannerImageCarousel = gql`
  mutation CreateOrUpdateElement_BannerImageCarousel(
    $inputGeneral: ConfigAppPageElementInput!
    $inputElement: ConfigAppPageElementInput_BannerImageCarousel!
  ) {
    createOrUpdateElement_BannerImageCarousel(
      inputGeneral: $inputGeneral
      inputElement: $inputElement
    )
  }
`
